<template>
  <span class="avatar-with-frame" :style="rootStyle">
    <platform-avatar
      class="avatar-with-frame__avatar"
      :src="avatar"
      :alt="avatarAlt"
      @error="$emit('avatar-error', $event)"
    />
    <avatar-frame-media
      v-if="hasFrame"
      class="avatar-with-frame__frame"
      :style="frameStyle"
      :animation-url="frameAnimationUrl"
      :preview-url="framePreviewUrl"
      :alt="frameAlt"
      :decorative="frameDecorative"
      :play="playFrame"
      @error="$emit('frame-error', $event)"
    />
  </span>
</template>

<script>
import AvatarFrameMedia from "./AvatarFrameMedia.vue"
import PlatformAvatar from "./PlatformAvatar.vue"

export default {
  name: "AvatarWithFrame",
  components: { AvatarFrameMedia, PlatformAvatar },
  props: {
    avatar: { type: String, default: "" },
    avatarAlt: { type: String, default: "" },
    frameAnimationUrl: { type: String, default: "" },
    framePreviewUrl: { type: String, default: "" },
    frameAlt: { type: String, default: "" },
    frameDecorative: { type: Boolean, default: true },
    playFrame: { type: Boolean, default: true },
    frameScale: { type: Number, default: 1.4 },
    size: { type: Number, default: 0 }
  },
  computed: {
    hasFrame() {
      return Boolean(this.frameAnimationUrl || this.framePreviewUrl)
    },
    framePercent() {
      const scale = Number.isFinite(this.frameScale) ? Math.min(2, Math.max(1, this.frameScale)) : 1.4
      return `${scale * 100}%`
    },
    frameStyle() {
      return { width: this.framePercent, height: this.framePercent }
    },
    rootStyle() {
      if (!Number.isFinite(this.size) || this.size <= 0) return null
      const size = `${this.size}px`
      return { width: size, height: size }
    }
  }
}
</script>

<style scoped>
.avatar-with-frame{position:relative;display:inline-block;width:40px;height:40px;flex:none;overflow:visible;isolation:isolate}
.avatar-with-frame__avatar{position:relative;z-index:0;width:100%;height:100%;box-sizing:border-box;border:var(--avatar-border,0);box-shadow:var(--avatar-shadow,none)}
.avatar-with-frame__frame{position:absolute;z-index:1;left:50%;top:50%;max-width:none;transform:translate(-50%,-50%);object-fit:contain;pointer-events:none}
</style>
